import React, { useState, useEffect, Fragment } from "react";

import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import useOnclickOutside from "react-cool-onclickoutside";

import {
  mapParser
} from "./sharedUtils";

let cachedVal = "";
const acceptedKeys = ["ArrowUp", "ArrowDown", "Escape", "Enter"];

const AutocompleBox = (props) => {
  const { onAutoFill, gmapApiKey, disabled } = props;
  const [isHidden, setIsHidden] = useState(false);
  const [currIndex, setCurrIndex] = useState(null);
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    cacheKey: "region-restricted",
    cache: 24 * 60 * 60,
    // requestOptions: {
    //   componentRestrictions: { country: "us" },
    // }
  });

  const hasSuggestions = status === "OK";

  const dismissSuggestions = () => {
    setCurrIndex(null);
    // clearSuggestions();
    setIsHidden(true);
  };

  const ref = useOnclickOutside(dismissSuggestions);

  const handleInput = (e) => {
    setValue(e.target.value);
    cachedVal = e.target.value;
  };

  const handleSelect = (suggestion) => () => {
    const { description, place_id } = suggestion;
    setValue(description, false);
    dismissSuggestions();
    getGeocode({ placeId: place_id }).then((result) => {
      console.log("result", result);
      const latLng = getLatLng(result[0]);
      const data = {
        ...latLng,
        place_id,
        address_1: mapParser.street(result[0]),
        address_2: mapParser.street2(result[0]),
        city: mapParser.city(result[0]),
        state: mapParser.province(result[0]),
        zipcode: mapParser.postalCode(result[0]),
        country: mapParser.country(result[0]),
        full_address: result[0].formatted_address,
      };
      console.log("data", data);
      if (onAutoFill) {
        onAutoFill(data);
      }
    });
  };

  const handleEnter = (idx) => () => {
    setCurrIndex(idx);
  };

  const handleLeave = () => {
    setCurrIndex(null);
  };
  const handleInputFocus = (e) => {
    setIsHidden(false);
  };

  const handleKeyDown = (e) => {
    if (!hasSuggestions || acceptedKeys.indexOf(e.key) < 0) return;

    if (e.key === "Enter" || e.key === "Escape") {
      dismissSuggestions();
      return;
    }

    let nextIndex = null;

    if (e.key === "ArrowUp") {
      e.preventDefault();
      nextIndex = currIndex ?? data.length;
      nextIndex = nextIndex && nextIndex > 0 ? nextIndex - 1 : null;
    } else {
      nextIndex = currIndex ?? -1;
      nextIndex = nextIndex < data.length - 1 ? nextIndex + 1 : null;
    }

    setCurrIndex(nextIndex);
    setValue(data[nextIndex] ? data[nextIndex].description : cachedVal, false);
  };

  const renderSuggestions = () => {
    const suggestions = data.map((suggestion, idx) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        <li
          key={place_id}
          id={`gmap-suggest-item-${idx}`}
          className={`gmap-suggest-item ${
            idx === currIndex ? `gmap-suggest-item-active` : ""
          }`}
          onClick={handleSelect(suggestion)}
          onMouseEnter={handleEnter(idx)}
          role="option"
          aria-selected={idx === currIndex}
        >
          <strong>{main_text}</strong>
          <small className="gmap-suggest-subtext">{secondary_text}</small>
        </li>
      );
    });

    return <Fragment>{suggestions}</Fragment>;
  };
  return (
    <div className="row with-forms">
    <div className="col-md-12">
        <div
          className="gmap-autocomplete"
          ref={ref}
          role="combobox"
          aria-owns="autocomplete-box"
          aria-haspopup="listbox"
          aria-expanded={hasSuggestions}
        >
          <label className="text-bold">
          <h5>
            <span>
            Save time by auto-populating information from Google Places!
            </span>
          </h5>
          </label>
          <input
            className="form-control"
            value={value}
            onChange={handleInput}
            onKeyDown={handleKeyDown}
            onFocus={handleInputFocus}
            disabled={disabled || !ready}
            placeholder="Type the name or address of the location"
            type="text"
            aria-autocomplete="list"
            aria-controls="autocomplete-box"
            aria-activedescendant={
              currIndex !== null ? `gmap-suggest-item-${currIndex}` : undefined
            }
          />
          {hasSuggestions && !isHidden && (
            <ul
              id="autocomplete-box"
              className="gmap-suggestions"
              onMouseLeave={handleLeave}
              role="listbox"
            >
              {renderSuggestions()}
            </ul>
          )}
        </div>
    
                
      </div>
    </div>
  );
};

const PlaceAutocompleteForm = (props) => {
  
  if (!window.google?.maps) return null;
  return <AutocompleBox {...props} />;
};

export default PlaceAutocompleteForm;
